// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/clear-air-turbulence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/clear-air-turbulence/clear-air-turbulence.js';

mount([g0]);
